import { combineReducers } from 'redux';

import alphabetFilter from './reducers/alphabetFilter';
import byId from './reducers/byId';
import customerAppointments from './reducers/customerAppointments';
import letters from './reducers/letters';
import list from './reducers/list';
import rewardCounter from './reducers/rewardCounter';
import customerCount from './reducers/customerCount';
import lettersPagination from './reducers/lettersPagination';
import marketingLeads from './marketingLeads/reducer';
import retention from './retention/reducers/retention';

export default combineReducers({
  byId,
  alphabetFilter,
  customerAppointments,
  list,
  letters,
  rewardCounter,
  customerCount,
  lettersPagination,
  marketingLeads,
  retention,
});
